module.exports = __webpack_public_path__ + "img/operation-back.39d091d8.png";